import { BuildingRightsType } from "by/gamefactory/cityversetycoon/networking/data/responses/user/BuildingRightsType";
import { Container, Text } from "pixi.js";
import { BuildingRankUpTextComponentsTextStyle } from "./BuildingRankUpTextComponentsTextStyle";

export class BuildingRankUpTopTextComponent extends Container {
    private static readonly LANDLORD_TEXT = 'You and your renters will share\nthe reward amount';
    private static readonly RENTER_TEXT = 'BUT you need to share the reward with\nyour Landlord and all other renters.';
    private text: Text;

    public constructor(role: BuildingRightsType) {
        super();
        let properText: string;
        switch (role) {
            case BuildingRightsType.OWNER:
            case BuildingRightsType.LANDLORD: {
                properText = BuildingRankUpTopTextComponent.LANDLORD_TEXT;
                break;
            }
            case BuildingRightsType.RENTER: {
                properText = BuildingRankUpTopTextComponent.RENTER_TEXT;
                break;
            }
        }
        this.text = new Text(properText, new BuildingRankUpTextComponentsTextStyle());
        this.addChild(this.text);
    }
}